/* Program Name: CustomDivs.js
 **  Description: several styled-components for custom divs
 **
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-09-23  STT  Initial program
 *********************************************************************************/

import { styled } from '@mui/system'
import React from 'react'

/**Custom Styled div for SidePanel headers */
export const SidePanelHeader = styled('div')(() => ({
  fontSize: 16,
  borderBottom: '2px solid black',
  margin: '16px 0px 0px 0px',
}))

////////// FLEX BOX DIVS ////////////////////

export const FlexBox = styled('div')(() => ({ display: 'flex' }))

export const FlexBoxFull = styled('div')(() => ({
  display: 'flex',
  width: '100%',
}))

export const FlexWrapFull = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  flexWrap: 'wrap',
}))

/**Custom Styled div for display flex */
export const FlexBoxOther = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  flexDirection: 'row',
  justifyContent: 'flex-startq',
  alignContent: 'flex-start',
  width: '100%',
}))

export const FlexFullWidth = styled('div')(({ overrideStyles }) => ({
  width: '100%',
  alignSelf: 'stretch',
  flex: '1 1 100%',
  display: 'flex',
  margin: '1%',
  ...overrideStyles,
}))

export const FlexHalfWidth = styled('div')(({ overrideStyles }) => ({
  width: '48%',
  margin: '1%',
  alignSelf: 'stretch',
  ...overrideStyles,
}))

export const FlexOneThirdWidth = styled('div')(() => ({
  width: '31%',
  margin: '1%',
  alignSelf: 'stretch',
}))

export const FlexOne = styled('div')(() => ({
  flex: 1,
}))

export const FlexTwo = styled('div')(() => ({
  flex: 2,
  margin: 8,
}))

export const FlexChild = styled('div')(() => ({
  flex: 1,
  flexBasis: '30%',
}))

export const FlexImage = styled('div')(({ overrideStyles }) => ({
  margin: 1,
  display: 'flex',
  overflow: 'hidden',
  justifyContent: 'center',
  alignItems: 'center',
  ...overrideStyles,
}))

export const FlexWrap = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
}))

/**Custom Styled div to wrap around DatePickers */
export const DateWrap = styled('div')(() => ({
  margin: '8px 0px 8px 0px',
}))

export const ErrorDiv = styled('div')(() => ({
  color: 'red',
}))

export const SquareButtonWrap = styled('div')(() => ({
  margin: '28px 6px 28px 12px',
}))

export const InlineTextFieldWrap = styled('div')(() => ({
  marginLeft: 24,
  marginRight: 24,
  flex: 1,
}))

export const ModalDiv600 = styled('div')(() => ({
  height: 600,
  overflowY: 'auto',
}))

export const ModalDivH80 = styled('div')(() => ({
  maxHeight: '80vh',
  overflowY: 'auto',
}))

export const ModalDivH90 = styled('div')(() => ({
  maxHeight: '90vh',
  overflowY: 'auto',
}))

export const HeaderWrap = ({ children }) => {
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 2 }}></div>
      <div style={{ flex: 8 }}>
        <h1>{children}</h1>
      </div>
      <div style={{ flex: 2 }}></div>
    </div>
  )
}
